import { CheckCircleTwoTone, UndoOutlined } from '@ant-design/icons';
import { Tag } from 'antd';
import dayjs from 'dayjs';
import { baseColors, semanticColors } from 'theme/colors';

import type { CommentStatus } from 'types/task/TaskComments';

interface CommentStatusTagProps {
  status: CommentStatus | undefined;
  createdAt?: string;
}

export function CommentStatusTag({ status, createdAt }: CommentStatusTagProps) {
  const formattedDate = createdAt ? dayjs(createdAt).format('lll') : undefined;

  if (status === 'Resolved') {
    return (
      <Tag
        icon={
          <CheckCircleTwoTone
            twoToneColor={[semanticColors.colorSuccess, baseColors.green1]}
          />
        }
        className="pl-0 bg-transparent text-color-success"
        title={formattedDate}
      >
        Marked as resolved
      </Tag>
    );
  }

  if (status === 'Unresolved') {
    return (
      <Tag
        icon={<UndoOutlined />}
        className="pl-0 bg-transparent text-smart-grey-5"
        title={formattedDate}
      >
        Re-opened
      </Tag>
    );
  }

  return null;
}
